import { usePeriod } from '@/app/context/PeriodContext';
import { usePeriodQuery } from '@/app/services/periodApi';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

export default function PeriodInitializer() {
  const { selectedPeriod, setSelectedPeriod } = usePeriod();
  const [size, setSize] = useState(5);

  const { data, isSuccess } = usePeriodQuery(size);

  useEffect(() => {
    if (isSuccess && data?.content) {
      setSelectedPeriod(data.content[0]);
    }
  }, [data, isSuccess, setSelectedPeriod]);

  return <Outlet />;
}
